export default "__VITE_ASSET__D5UrqU_k__"